import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlDetalhesMetasEducacaoEmpenho = '/service/contabilidade/transparencia/metaEducacao/'

class DetalhesMetasEducacaoEmpenhoService extends BaseService {
    constructor() {
        super(NOME_TOKEN_ACESSO_DIRETO)
    }

    consultar(filtro) {
        let data = {
            sequencia: filtro.sequencia ? filtro.sequencia : '',
            mesLiquidacao: filtro.mesLiquidacao ? filtro.mesLiquidacao : '',
            exercicio: filtro.exercicio ? filtro.exercicio : '',
            chCategoriaContabil: filtro.chCategoriaContabil ? filtro.chCategoriaContabil : '',
        }
        return this.conex.post(urlDetalhesMetasEducacaoEmpenho + 'consultaMetasEducacaoEmpenho/', JSON.stringify(data))
    }
}

export default DetalhesMetasEducacaoEmpenhoService
